/* eslint-disable no-unsafe-optional-chaining */
import { ModuleArticleCard } from '@components';
import { Flex } from '@styles';
import { func, object } from 'prop-types';
import React, { useMemo, useState } from 'react';

const SituationLayout = ({ onFinish, situation }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleButtonClick = (i) => async () => {
    if (i < situation?.steps?.length - 1) {
      setCurrentStep((prevState) => prevState + 1);
    } else {
      await onFinish();
      setCurrentStep(0);
    }
  };

  const handleButtonClickBack = (i) => () => {
    if (i > 0) {
      setCurrentStep((prevState) => prevState - 1);
    }
  };

  const memoStepsComponents = useMemo(
    () =>
      situation?.steps.map((step, index) => (
        <ModuleArticleCard
          data={{
            image: situation?.image,
            topText: situation?.description,
            ...step,
          }}
          isNext={index < situation?.steps?.length - 1}
          isPrevious={index > 0}
          lastIndexChanged={currentStep}
          onClick={handleButtonClick(index)}
          onClickBack={handleButtonClickBack(index)}
        />
      )),
    [currentStep, situation]
  );

  return <Flex>{memoStepsComponents?.[currentStep]}</Flex>;
};

SituationLayout.propTypes = {
  onFinish: func.isRequired,
  situation: object.isRequired,
};

export default SituationLayout;
